var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16297 1.59401C3.25038 2.40357 2.34117 3.25218 1.61682 4.23729C1.4819 4.42077 1.38203 4.57865 1.31829 4.70612C1.24601 4.85069 1.24601 4.89902 1.31829 5.04359C1.38203 5.17106 1.4819 5.32894 1.61681 5.51242C2.34042 6.49653 3.24838 7.34903 4.16266 8.15545C4.42174 8.38349 4.44722 8.77863 4.2192 9.03775C3.99116 9.29688 3.59624 9.32209 3.33711 9.09405C2.35536 8.22841 1.38658 7.3094 0.609749 6.25291C0.31992 5.85874 -2.13474e-07 5.38372 -1.91231e-07 4.87486C-1.68988e-07 4.36599 0.319924 3.89096 0.609757 3.4968C1.38385 2.44404 2.36271 1.51986 3.33684 0.655929C3.59597 0.427896 3.9912 0.452834 4.21923 0.711965C4.44725 0.971081 4.42206 1.36597 4.16297 1.59401Z",
    fill: "#1F2445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.e9d3b0ef9d09fff03a82a662eb2466dd.svg";
export { ForwardRef as ReactComponent };